import * as Animate from "react-reveal";

const points = [
  { number: "01", title: "Zero-internet access" },
  { number: "02", title: "Short video lessons" },
  { number: "03", title: "Interactive methodology" },
  { number: "04", title: "Business case projects" },
];

const NucleusInfrastructureSection = () => {
  return (
    <section className="bg-primary2 py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Why the nucleus
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight text-white font-poppins font-bold mb-5 tracking-[-0.03em]">
                A learning product designed around infrastructure reality.
              </h2>
              <p className="text-indigo-100 text-base font-poppins leading-relaxed m-0">
                Instead of asking every learner to solve the connectivity
                problem, The Nucleus brings the learning closer to them.
              </p>
            </div>
          </Animate.Fade>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((point) => (
              <Animate.Fade bottom key={point.number}>
                <article
                  className="h-full rounded-2xl border border-white/15 p-6 flex items-center gap-4"
                  style={{ background: "rgba(255,255,255,0.06)" }}
                >
                  <span className="text-secondary font-poppins text-xs font-extrabold tracking-widest">
                    {point.number}
                  </span>
                  <h3 className="text-white font-poppins font-bold text-base m-0">
                    {point.title}
                  </h3>
                </article>
              </Animate.Fade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NucleusInfrastructureSection;
